var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ProgressButtonsResponsivityManager } from "survey-core";
import { SurveyNavigationBase } from "./reactSurveyNavigationBase";
import { ReactElementFactory } from "./element-factory";
import { SurveyElementBase } from "./reactquestion_element";
var SurveyProgressButtons = /** @class */ (function (_super) {
    __extends(SurveyProgressButtons, _super);
    function SurveyProgressButtons(props) {
        var _this = _super.call(this, props) || this;
        _this.listContainerRef = React.createRef();
        return _this;
    }
    Object.defineProperty(SurveyProgressButtons.prototype, "model", {
        get: function () {
            return this.props.model;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyProgressButtons.prototype, "container", {
        get: function () {
            return this.props.container;
        },
        enumerable: false,
        configurable: true
    });
    SurveyProgressButtons.prototype.onResize = function (canShowItemTitles) {
        this.setState({ canShowItemTitles: canShowItemTitles });
        this.setState({ canShowHeader: !canShowItemTitles });
    };
    SurveyProgressButtons.prototype.onUpdateScroller = function (hasScroller) {
        this.setState({ hasScroller: hasScroller });
    };
    SurveyProgressButtons.prototype.onUpdateSettings = function () {
        this.setState({ canShowItemTitles: this.model.showItemTitles });
        this.setState({ canShowFooter: !this.model.showItemTitles });
    };
    SurveyProgressButtons.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: this.model.getRootCss(this.props.container), style: { "maxWidth": this.model.progressWidth }, role: "progressbar", "aria-valuemin": 0, "aria-valuemax": 100, "aria-label": this.model.progressBarAriaLabel },
            this.state.canShowHeader ? React.createElement("div", { className: this.css.progressButtonsHeader },
                React.createElement("div", { className: this.css.progressButtonsPageTitle, title: this.model.headerText }, this.model.headerText)) : null,
            React.createElement("div", { className: this.css.progressButtonsContainer },
                React.createElement("div", { className: this.model.getScrollButtonCss(this.state.hasScroller, true), role: "button", onClick: function () {
                        return _this.clickScrollButton(_this.listContainerRef.current, true);
                    } }),
                React.createElement("div", { className: this.css.progressButtonsListContainer, ref: this.listContainerRef },
                    React.createElement("ul", { className: this.css.progressButtonsList }, this.getListElements())),
                React.createElement("div", { className: this.model.getScrollButtonCss(this.state.hasScroller, false), role: "button", onClick: function () {
                        return _this.clickScrollButton(_this.listContainerRef.current, false);
                    } })),
            this.state.canShowFooter ? React.createElement("div", { className: this.css.progressButtonsFooter },
                React.createElement("div", { className: this.css.progressButtonsPageTitle, title: this.model.footerText }, this.model.footerText)) : null));
    };
    SurveyProgressButtons.prototype.getListElements = function () {
        var _this = this;
        var buttons = [];
        this.survey.visiblePages.forEach(function (page, index) {
            buttons.push(_this.renderListElement(page, index));
        });
        return buttons;
    };
    SurveyProgressButtons.prototype.renderListElement = function (page, index) {
        var _this = this;
        var text = SurveyElementBase.renderLocString(page.locNavigationTitle);
        return (React.createElement("li", { key: "listelement" + index, className: this.model.getListElementCss(index), onClick: this.model.isListElementClickable(index)
                ? function () { return _this.model.clickListElement(page); }
                : undefined, "data-page-number": this.model.getItemNumber(page) },
            React.createElement("div", { className: this.css.progressButtonsConnector }),
            this.state.canShowItemTitles ? React.createElement(React.Fragment, null,
                React.createElement("div", { className: this.css.progressButtonsPageTitle, title: page.renderedNavigationTitle }, text),
                React.createElement("div", { className: this.css.progressButtonsPageDescription, title: page.navigationDescription }, page.navigationDescription)) : null,
            React.createElement("div", { className: this.css.progressButtonsButton },
                React.createElement("div", { className: this.css.progressButtonsButtonBackground }),
                React.createElement("div", { className: this.css.progressButtonsButtonContent }),
                React.createElement("span", null, this.model.getItemNumber(page)))));
    };
    SurveyProgressButtons.prototype.clickScrollButton = function (listContainerElement, isLeftScroll) {
        if (!!listContainerElement) {
            listContainerElement.scrollLeft += (isLeftScroll ? -1 : 1) * 70;
        }
    };
    SurveyProgressButtons.prototype.componentDidMount = function () {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        setTimeout(function () {
            _this.respManager = new ProgressButtonsResponsivityManager(_this.model, _this.listContainerRef.current, _this);
        }, 10);
    };
    SurveyProgressButtons.prototype.componentWillUnmount = function () {
        if (!!this.respManager) {
            this.respManager.dispose();
        }
        _super.prototype.componentWillUnmount.call(this);
    };
    return SurveyProgressButtons;
}(SurveyNavigationBase));
export { SurveyProgressButtons };
ReactElementFactory.Instance.registerElement("sv-progress-buttons", function (props) {
    return React.createElement(SurveyProgressButtons, props);
});
